import styled from 'styled-components'

import { TYPOGRAPHY_COLOR } from '../../../styles/variables'

const defaultHeadingsStyles = `
  font-family: 'Poppins', sans-serif;
  font-weight: bold;
  color: ${TYPOGRAPHY_COLOR};
`

export const h1 = styled.h1`
  ${defaultHeadingsStyles}
  font-size: 42px;
  line-height: 1.33;
`

export const h2 = styled.h2`
  ${defaultHeadingsStyles}
  font-size: 36px;
  line-height: 1.33;
`

export const h3 = styled.h3`
  ${defaultHeadingsStyles}
  font-size: 24px;
`

export const h4 = styled.h4`
  ${defaultHeadingsStyles}
  font-size: 20px;
  line-height: 1.5;
`

export const h5 = styled.h5`
  ${defaultHeadingsStyles}
  font-size: 18px;
  margin-bottom: 15px;
`

export const h6 = styled.h6`
  ${defaultHeadingsStyles}
  font-size: 16px;
`

export const paragraph1 = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
`

export const paragraph2 = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
`

export const small = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
`

export const paragraphDefault = styled.p``
